import { apiDelete, apiGet, apiSend } from './httpClient'
import type { CreatePlaceInput, TripPlace, UpdatePlaceInput } from './types'

export const listPlaces = (tripId: string): Promise<TripPlace[]> =>
  apiGet(`/trips/${tripId}/places`)
export const addPlace = (tripId: string, input: CreatePlaceInput): Promise<TripPlace> =>
  apiSend('POST', `/trips/${tripId}/places`, input)
export const updatePlace = (tripId: string, placeId: string, input: UpdatePlaceInput): Promise<TripPlace> =>
  apiSend('PATCH', `/trips/${tripId}/places/${placeId}`, input)
export const deletePlace = (tripId: string, placeId: string): Promise<void> =>
  apiDelete(`/trips/${tripId}/places/${placeId}`)
